import { render, staticRenderFns } from "./ledconfig.vue?vue&type=template&id=0acdb5b5"
import script from "./ledconfig.vue?vue&type=script&lang=js"
export * from "./ledconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports